import React, {useState} from 'react';
import Typed from 'react-typed';

import {Text, Scroll} from '../../../components';
import {classNames} from '../../../components/utils';
import styles from './RecognitionDemo.module.scss';

import ProfileImage from '../../../images/avatar.jpg';

interface Props {
  loadAnimation?: boolean;
}

const Message = ({emoji}) => {
  return (
    <>
      <div className={styles.DateSeparator} />
      <div className={styles.Message}>
        <div className={styles.Profile}>
          <img src={ProfileImage} />
        </div>
        <div className={styles.Content}>
          <div className={styles.ContentInfo}>
            <div className={styles.ContentInfoName}>Jennifer Reed</div>
            <div className={styles.ContentInfoDate}>2:30 PM</div>
          </div>
          <div className={styles.ContentValue}>
            +1 {emoji} to <span className={styles.NameTag}>@matt</span> for
            hosting our first ever online intern workshop and onboarding these
            new faces into our company!
          </div>
        </div>
      </div>
    </>
  );
};

const RecognitionDemo: React.FC<Props> = (props) => {
  const [typeComplete, setTypeComplete] = useState(0);
  const [emojiSelect, setEmojiSelect] = useState(0);

  const emojis = ['👑', '🧠', '🌈', '☃️', '🍉'];

  const EmojiOption = ({emojiIndex, children}) => (
    <div
      className={classNames(
        styles.EmojiOption,
        emojiSelect == emojiIndex && styles.emojiSelected,
      )}
      onClick={() => {
        setEmojiSelect(emojiIndex);
      }}
    >
      {children}
    </div>
  );

  const emojiOptions = emojis.map((item, index) => (
    <EmojiOption emojiIndex={index} key={index}>
      {item}
    </EmojiOption>
  ));

  const messageMarkup =
    typeComplete === 1 ? <Message emoji={emojis[emojiSelect]} /> : '';

  return (
    <>
      <div className={styles.ChangeEmoji}>
        <Text>
          You can <b>customize your emoji</b> to match your company's brand and
          products!
        </Text>
        <div className={styles.EmojiList}>
          {emojiOptions}
          <div className={styles.CustomEmoji}>+ custom emoji</div>
        </div>
      </div>
      <div className={styles.RecognitionDemo}>
        <div className={styles.ChatInfo}>
          <div className={styles.Title}>#ekipo</div>
          <div className={styles.Description}>
            Share some points, share some love.
          </div>
          <div className={styles.AddOptions}>
            <div className={styles.AddApp}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
              </svg>
              Add an app
            </div>
            <div className={styles.AddPeople}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M12 2c2.757 0 5 2.243 5 5.001 0 2.756-2.243 5-5 5s-5-2.244-5-5c0-2.758 2.243-5.001 5-5.001zm0-2c-3.866 0-7 3.134-7 7.001 0 3.865 3.134 7 7 7s7-3.135 7-7c0-3.867-3.134-7.001-7-7.001zm6.369 13.353c-.497.498-1.057.931-1.658 1.302 2.872 1.874 4.378 5.083 4.972 7.346h-19.387c.572-2.29 2.058-5.503 4.973-7.358-.603-.374-1.162-.811-1.658-1.312-4.258 3.072-5.611 8.506-5.611 10.669h24c0-2.142-1.44-7.557-5.631-10.647z" />
              </svg>
              Add people to this channel
            </div>
          </div>
        </div>
        <div className={styles.Messages}>{messageMarkup}</div>
        <div className={styles.InputBox}>
          <div className={styles.Attachments}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M7 4v12.434c0 .636.28 1.239.765 1.649l3.598 3.043c.368.311.907.311 1.274 0l3.599-3.043c.485-.41.764-1.013.764-1.649v-13.934c0-.276-.224-.5-.5-.5h-5c-.276 0-.5.224-.5.5v9.697c0 .229.091.448.253.61l.513.513c.129.129.339.129.469 0l.513-.513c.161-.161.252-.381.252-.61v-7.197h2v7.585c0 .531-.211 1.04-.586 1.415l-1.707 1.707c-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-1.707-1.707c-.375-.375-.586-.884-.586-1.415v-10.585c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2v14.606c0 1.162-.508 2.265-1.39 3.021l-4.715 4.042c-.257.22-.577.331-.895.331-.319 0-.638-.111-.896-.332l-4.714-4.041c-.883-.756-1.39-1.859-1.39-3.021v-12.606h2z" />
            </svg>
          </div>
          <div className={styles.Input}>
            <Scroll>
              <Scroll.LoadContent>
                <Typed
                  stopped={typeComplete === 1}
                  strings={[
                    `+1 ${emojis[emojiSelect]} to @matt for hosting our int`,
                    `+1 ${
                      emojis[emojiSelect]
                    } to @matt for hosting our first ever online intern workshop and onboarding these
                    new faces into our company!`,
                  ]}
                  backSpeed={10}
                  typeSpeed={20}
                  onComplete={(self) => {
                    self.destroy();
                    setTypeComplete(1);
                  }}
                />
              </Scroll.LoadContent>
            </Scroll>
          </div>
          <div className={styles.Buttons}>
            <div className={styles.At}>@</div>
            <svg
              className={styles.Smile}
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.507 13.941c-1.512 1.195-3.174 1.931-5.506 1.931-2.334 0-3.996-.736-5.508-1.931l-.493.493c1.127 1.72 3.2 3.566 6.001 3.566 2.8 0 4.872-1.846 5.999-3.566l-.493-.493zm-9.007-5.941c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5zm7 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5z" />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecognitionDemo;
